import type { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

import { ScreenHeader } from './ScreenHeader';

export interface PageHeaderProps {
  breadcrumb?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const pageHeaderSx = { mb: 5 } as const;

export const PageHeader = React.forwardRef<HTMLDivElement, PageHeaderProps>(({ sx, ...slots }, ref) => (
  <ScreenHeader ref={ref} headingLevel={1} {...slots} sx={[pageHeaderSx, ...(Array.isArray(sx) ? sx : [sx])]} />
));

PageHeader.displayName = 'PageHeader';
